<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label=" Page ii. " class="page" epub:type="pagebreak" id="pii" role="doc-pagebreak"></span><span aria-label=" Page iii. " class="page" epub:type="pagebreak" id="piii" role="doc-pagebreak"></span>Jane Addams’s Evolutionary Theorizing</h1>
<h1 class="bk1">Constructing “Democracy and Social Ethics”</h1>
<p class="bkau">Marilyn Fischer</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1"><span class="sm">CHICAGO</span> <span class="sm"></span> <span class="sm">LONDON</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Fischer-OA-0003.vue?4e8a3882